import React from "react";
import ReactDOM from "react-dom/client";
import { Store } from "@ludens-reklame/rubics-v3-sdk/store/types";
import { Section } from "@ludens-reklame/rubics-v3-sdk/section/types";
import { App } from "./app";
import { ErrorBoundary } from "./internal-components/error-boundary/error-boundary";
import Header from "./components/header/header";
import Footer from "./components/footer/footer";

// lazy loaded components
const Hero = React.lazy(() => import("./components/hero/hero"));
const Faq = React.lazy(() => import("./components/faq/faq"));
const DefinitionList = React.lazy(
  () => import("./components/definition-list/definition-list")
);
const References = React.lazy(
  () => import("./components/references/references")
);
const Cards = React.lazy(() => import("./components/cards/cards"));
const Map = React.lazy(() => import("./components/map/map"));

declare const _STORE: Store;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary root={true}>
      <App store={_STORE} renderer={renderSection} />
    </ErrorBoundary>
  </React.StrictMode>
);

function renderSection(
  section: Section,
  children?: React.ReactNode
): React.ReactNode {
  let suspend: boolean = true;
  let Component: React.ComponentType<any>;
  const domElem = document.getElementById(section.name);

  switch (section.component) {
    case "Header":
      Component = Header;
      suspend = false;
      break;
    case "Footer":
      Component = Footer;
      suspend = false;
      break;
    case "Hero":
      Component = Hero;
      break;
    case "Faq":
      Component = Faq;
      break;
    case "DefinitionList":
      Component = DefinitionList;
      break;
    case "Cards":
      Component = Cards;
      break;
    case "References":
      Component = References;
      break;
    case "Map":
      Component = Map;
      break;
    default:
      return null;
  }

  if (!suspend) {
    return (
      <ErrorBoundary>
        <Component {...section.props}>{children}</Component>
      </ErrorBoundary>
    );
  }

  return (
    <React.Suspense
      fallback={
        domElem ? (
          <div dangerouslySetInnerHTML={{ __html: domElem.innerHTML }} />
        ) : null
      }
    >
      <ErrorBoundary>
        <Component {...section.props}>{children}</Component>
      </ErrorBoundary>
    </React.Suspense>
  );
}
